import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../styles/logo.png";
import { FaBars, FaTimes, FaEdit } from "react-icons/fa";
import api from "../api/api";
import { ENDPOINTS } from "../api/endpoints";
import ShareIcon from "@mui/icons-material/Share";
import IconButton from "@mui/material/IconButton";
import ShareMenu from "../utils/ShareMenu";
import useBodyScrollLock from "../hooks/useBodyScrollLock";
import usePolling from "../hooks/useMessagePolling";

function NavigationTalent() {
  const [messagesData, setMessagesData] = useState({ totalCount: 0 });
  const [faveCount, setFaveCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  useBodyScrollLock(menuOpen);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newName, setNewName] = useState("");
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [userCredits, setUserCredits] = useState(0);
  const [unreadCount, setUnreadCount] = useState(0);
  const userId = localStorage.getItem("userId") || "";
  const email = localStorage.getItem("email") || "";
  const [userName, setUserName] = useState(localStorage.getItem("userName") || "");
  const [resumeName, setResumeName] = useState(localStorage.getItem("resumeName") || "");

  const loggedUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
  const [firstname, setFirstname] = useState(
  loggedUser?.data?.userFirstName || ""
);

const [lastname, setLastname] = useState(
  loggedUser?.data?.userLastName || ""
);
  const [accountStatus, setAccountStatus] = useState(0);
  const siteBaseUrl = (
    process.env.REACT_APP_SITE_BASE_URL || window.location.origin
  ).replace(/\/+$/, "");
  const navItems = [
    { to: "/myresume", label: "Home" },
    { to: "/castingcalls", label: "Casting Notices" },
    { to: "/submission-history", label: "Submission History" },
    { to: "/profile", label: "Profile" },
    { to: "/myresume", label: "My Resume" },
    { to: "/account", label: "My Account" },
    {
      to: "/messaging",
      label: "Mail",
      badge: unreadCount > 0 ? ` (${unreadCount})` : null,
    },
  ];
  const fetchUnreadCount = async () => {
    if (!email) return;
    try {
      const resp = await api.get(
        ENDPOINTS.getUnreadMessageCount(),
        { params: { email } }
      );
      setUnreadCount(resp.data?.data?.unreadMessageCount || 0);
    } catch (err) {
      console.error("Unread count fetch failed:", err);
    }
  };
  usePolling(fetchUnreadCount, {
    enabled: !!email,
    interval: 30000,
    immediate: true,
  });
  useEffect(() => {
    const refresh = () => fetchClientDetails();
     console.log(firstname, lastname);
    window.addEventListener("client-details-updated", refresh);
    return () =>
      window.removeEventListener("client-details-updated", refresh);
  }, []);
 
  useEffect(() => {
    if (!userId) return;
    const fetchMessages = async () => {
      try {
        const resp = await api.get(
          ENDPOINTS.getUserResumeMessagesWithCounts(),
          { params: { userId, pageNumber: 1, pageSize: 2 } }
        );
        setMessagesData(resp.data || { totalCount: 0 });
      } catch (err) {
        setError(err.message);
      }
    };
    fetchMessages();
  }, [userId]);
  useEffect(() => {
    if (!userId) return;
    const fetchTalentProfile = async () => {
      try {
        const resp = await api.get(ENDPOINTS.getTalentProfile({ userId }));
        setFaveCount(resp.data?.data?.faveCount || 0);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchTalentProfile();
  }, [userId]);
  useEffect(() => {
    if (!userId) return;
    const fetchResumeName = async () => {
      try {
        const resp = await api.get(ENDPOINTS.getUserName({ userId }));
        const name = resp.data?.userName || userName;
        setResumeName(name);
        localStorage.setItem("resumeName", name);
      } catch (err) {
        console.error("Failed to fetch resume name", err);
      }
    };
    fetchResumeName();
  }, [userId]);
  const fetchClientDetails = async () => {
    if (!userId) return;
    try {
      const res = await api.get(
        ENDPOINTS.getUserActiveStatus({ userId })
      );
      setAccountStatus(res.data?.isActive ?? 0);
    } catch (err) {
      console.error("Failed to fetch account status", err);
    }
  };
  useEffect(() => {
    if (!email) return;
    fetchClientDetails();
  }, [email]);
  const membershipStatus =
    accountStatus === 1
      ? "active"
      : accountStatus === 2
        ? "free-trial"
        : "inactive";
  const vanityUrl = resumeName?.trim()
    ? `${siteBaseUrl}/${encodeURIComponent(resumeName.trim().toLowerCase())}`
    : "";
  const openShare = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const closeShare = () => setAnchorEl(null);
  const handleUpdateName = async () => {
    if (!newName.trim()) return;
    setLoading(true);
    try {
      await api.post(ENDPOINTS.updateResumeName({ userId, name: newName }));
      setResumeName(newName);
      setUserName(newName);
      localStorage.setItem("userName", newName);
      localStorage.setItem("resumeName", newName);
      setEditing(false);
      setError(null);
    } catch {
      setError("Failed to update name");
    } finally {
      setLoading(false);
    }
  };
  const handleLogout = () => {
    const rememberedUsername = localStorage.getItem("rememberedUsername");
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });
    if (rememberedUsername) {
      localStorage.setItem("rememberedUsername", rememberedUsername);
    }
    localStorage.setItem("logout", Date.now());
    window.location.replace("/login");
  };
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <img src={logo} alt="DirectSubmit" className="logo-img" />
          <div className="nav-links">
            {navItems.slice(0, 3).map((item) => (
              <Link key={item.to} to={item.to} className="nav-link">
                {item.label}
                {item.badge && <span className="badge">{item.badge}</span>}
              </Link>
            ))}
          </div>
        </div>
        <div className="navbar-right nav-links">
          {navItems.slice(3).map((item) =>
            item.label === "Mail" ? (
              <Link key={item.to} to={item.to} className="mail-nav-btn">
                {item.label}
                {item.badge && <span>&nbsp;{item.badge}</span>}
              </Link>
            ) : item.label === "Profile" ? (
              <div key={item.to} className="profile-wrapper">
                <Link to="/account">
                  <span className={`status-badge ${membershipStatus}`}>
                    {membershipStatus === "active"
                      ? "Active"
                      : membershipStatus === "free-trial"
                        ? "Free Trial"
                        : "Inactive"}
                  </span>
                </Link>
                <Link to={item.to} className="nav-link">
                  {item.label}
                </Link>
              </div>
            ) : (
              <Link key={item.to} to={item.to} className="nav-link">
                {item.label}
              </Link>
            )
          )}
          <button className="sign-out-btn" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
        <div
          className="hamburger-icon"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
      <div className="navbar-bottom talent-bottom">
        <div className="navbar-left">
          <Link to="/view-notifications" className="bottom-link">
            Views: {messagesData.totalCount}
          </Link>
          <span className="bottom-link">Favorited: {faveCount}</span>
        </div>
        <div className="navBarCenter">
          {!editing ? (
            <div
              className="bottom-link"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: 24, display: "flex", justifyContent: "flex-start", marginRight: 16 }}>
                <FaEdit
                  size={14}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setEditing(true);
                    setNewName(resumeName);
                  }}
                />
              </div>
              <a
                href={vanityUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  flex: 1,
                  textAlign: "center",
                  fontSize: "14px",
                  color: "#90b5fe",
                }}
              >
                {`${siteBaseUrl.replace(/^https?:\/\/ /, "")}/${resumeName}`}
              </a>
              <div style={{ width: 24, display: "flex", justifyContent: "flex-end", marginLeft: 16 }}>
                <IconButton
                  onClick={openShare}
                  sx={{ padding: "2px" }}
                >
                  <ShareIcon sx={{ fontSize: "14px" }} />
                </IconButton>
              </div>
            </div>
          ) : (
            <div className="bottom-link">
              <input
                value={newName}
                onChange={(e) => setNewName(e.target.value.toLowerCase())}
              />
              <button onClick={handleUpdateName} disabled={loading}>
                {loading ? "..." : "Update"}
              </button>
              <button onClick={() => setEditing(false)}>Cancel</button>
            </div>
          )}
        </div>
        <div className="navbar-right">
          <Link
            to="/castingcalls?openRoleAlerts=true"
            className="bottom-link"
          >
            Edit Role Alerts
          </Link>
          <Link
            to="/notifications"
            className="bottom-link"
          >
            Notifications & Privacy
          </Link>
        </div>
      </div>
   <ShareMenu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={closeShare}
  shareUrl={vanityUrl}
  shareType="vanity"
  talentName={`${firstname} ${lastname}`.trim()}
/>
      {menuOpen && (
        <div className="mobile-menu">
          <button
            className="mobile-menu-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <FaTimes />
          </button>
          {navItems.map((item) => (
            <React.Fragment key={item.to}>
              <Link
                to={item.to}
                className="mobile-link"
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
                {item.badge && (
                  <span className="badge">{item.badge}</span>
                )}
              </Link>
              {item.label === "Profile" && (
                <Link
                  to="/account"
                  className="mobile-link"
                  onClick={() => setMenuOpen(false)}
                >
                  <span className={`status-badge ${membershipStatus}`}>
                    {membershipStatus === "active"
                      ? "Active"
                      : membershipStatus === "free-trial"
                        ? "Free Trial"
                        : "Inactive"}
                  </span>
                </Link>
              )}
            </React.Fragment>
          ))}
          <Link
            to="/notifications"
            className="mobile-link"
            onClick={() => setMenuOpen(false)}
          >
            Notifications & Privacy
          </Link>
          <Link
            to="/view-notifications"
            className="mobile-link"
            onClick={() => setMenuOpen(false)}
          >
            Views: {messagesData.totalCount}
          </Link>
          <div className="mobile-link">
            Favorited: {faveCount}
          </div>
          <div className="mobile-link">
            {!editing ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <FaEdit
                  size={16}
                  style={{
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                  onClick={() => {
                    setEditing(true);
                    setNewName(resumeName);
                  }}
                />
                <a
                  href={vanityUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    flex: 1,
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: "#90b5fe",
                  }}
                >
                  {`${siteBaseUrl.replace(/^https?:\/\/ /, "")}/${resumeName}`}
                </a>
                <IconButton
                  size="small"
                  onClick={openShare}
                  sx={{
                    padding: "2px",
                    color: "inherit",
                  }}
                >
                  <ShareIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <input
                  value={newName}
                  onChange={(e) => setNewName(e.target.value.toLowerCase())}
                />
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                  }}
                >
                  <button
                    onClick={async () => {
                      await handleUpdateName();
                      setMenuOpen(false);
                    }}
                    disabled={loading}
                  >
                    {loading ? "..." : "Update"}
                  </button>
                  <button
                    onClick={() => {
                      setEditing(false);
                      setMenuOpen(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
          <button
            className="mobile-signout"
            onClick={handleLogout}
          >
            Sign Out
          </button>
        </div>
      )}
      {error && (
        <div className="navbar-error">
          <small style={{ color: "red" }}>{error}</small>
        </div>
      )}
    </nav>
  );
}
export default NavigationTalent;